(() => {
  const SELECTOR = '[data-announcement-marquee]';

  function init(root) {
    const storageKey = root.dataset.storageKey;
    const designMode = root.dataset.designMode === 'true';
    const closeBtn = root.querySelector('[data-close-announcement]');

    if (!designMode && storageKey && sessionStorage.getItem(storageKey)) {
      root.classList.add('announcement-bar-marquee--dismissed');
      return;
    }

    closeBtn?.addEventListener('click', () => {
      root.classList.add('announcement-bar-marquee--dismissed');
      if (storageKey && !designMode) {
        sessionStorage.setItem(storageKey, '1');
      }
    });
  }

  document.querySelectorAll(SELECTOR).forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.(SELECTOR).forEach(init);
  });
})();
